import { DataModel } from "common/models/utility-models/base-model";
import { loc, mentor } from "./internship-company-form-meta.model";

export class CompanyModel extends DataModel {
    internshipCompanyId: any = '';
    companyName: any = '';
    year: any = '';
    companyLocation: loc | any = [];
    companyMentor: mentor | any = [];
    locid:number;
    mentorid:number;
  }
  